export const EMPTY_IMAGE_PATH = '/images/no-image.png';
export const EMPTY_COVER_IMAGE_PATH = '/images/surah.webp';
